module.exports = __webpack_public_path__ + "img/offline.8739a36b.svg";